import * as React from "react";
import { Button, type ButtonProps } from "./button";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
import { cn } from "@/lib/utils";

interface ActionButtonProps extends ButtonProps {
  tooltip: string;
}

/**
 * Compact ghost icon-button for table row actions. Defaults to a 32px square
 * (the `size="icon"` button is 40px, which leaves the small 14px action icons
 * looking far apart in a row). Override via `className` if a larger hit area is
 * needed.
 */
const ActionButton = React.forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ tooltip, "aria-label": ariaLabel, className, ...props }, ref) => (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={ref}
          size="icon"
          variant="ghost"
          aria-label={ariaLabel ?? tooltip}
          className={cn("h-8 w-8", className)}
          {...props}
        />
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  ),
);
ActionButton.displayName = "ActionButton";

export { ActionButton };
